<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Filter Incidents</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close Incidents Filter"
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="filter-content d-flex m-0 pt-4 pb-2 flex-wrap" style="justify-content: space-evenly">

  <div style="padding: 5px !important;">
    <button mat-raised-button type="button" (click)="onSelectSites()" [matBadge]="'' + (selected_site_ids.length || 'All')" class="mx-3 mt-2">
      <mat-icon>location_on</mat-icon> {{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites') }}
    </button>
  </div>

  <div style="padding: 5px !important;">
    <button mat-raised-button type="button" (click)="onSelectUsers()" [matBadge]="'' + (selected_user_ids.length || 'All')" class="mx-3 mt-2">
      <mat-icon>account_circle</mat-icon> Affected Users
    </button>
  </div>

  <div style="padding: 5px !important;" *ngIf="!hide_assets">
    <button mat-raised-button type="button" (click)="onSelectAssets()" [matBadge]="'' + (selected_asset_ids.length || 'All')" class="mx-3 mt-2">
      <mat-icon>forklift</mat-icon> Assets
    </button>
  </div>

  <div style="padding: 5px !important;">
    <mat-form-field class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic" style="width: 180px;">
      <mat-label>Type</mat-label>
      <mat-select placeholder="Type" [(ngModel)]="type" matTooltip="Filter incidents by type." name="type">
        <mat-option value="">All</mat-option>
        <mat-option *ngFor="let incident_type of utils.getIncidentTypes()" [value]="incident_type">{{ incident_type }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div style="padding: 5px !important;">
    <mat-form-field class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic" style="width: 140px;">
      <mat-label>Status</mat-label>
      <mat-select placeholder="Status" [(ngModel)]="status" matTooltip="Filter incidents by status." name="status">
        <mat-option value="">All</mat-option>
        <mat-option [value]="status.toLowerCase()" *ngFor="let status of utils.getIncidentStatuses()">{{ status }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div style="padding: 0 1px !important;">
    <app-date-range-picker
      dateRangeTitle="Select Date Range"
      dateRangePlaceholder="Select Date Range"
      dateRangeTooltip="Filter incidents by date range."
      [dateRangeInput]="date_range"
      (dateRangeOutput)="getOutputDateRange($event)">
    </app-date-range-picker>
  </div>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex flex-wrap justify-content-center my-2 py-2">
  <div class="p-2">
    <button type="button" mat-raised-button color="primary" (click)="onSaveAndClose()">
      <mat-icon>filter_list</mat-icon> Apply Filters
    </button>
  </div>

  <div class="p-2">
    <button type="button" mat-raised-button color="secondary" (click)="onClearAndClose()">
      <mat-icon>clear_all</mat-icon> Clear Filters
    </button>
  </div>

  <div class="p-2" *ngIf="date_range.length == 2">
    <button type="button" mat-raised-button color="secondary" (click)="onClearDateRange()">
      <mat-icon>clear</mat-icon> Clear Date Range
    </button>
  </div>
</mat-dialog-actions>
